(function () {
  function bind () {
    var nodes = document.querySelectorAll('.reveal, .reveal-scale')
    if (!nodes.length) return

    if (typeof IntersectionObserver === 'undefined') {
      nodes.forEach(function (n) { n.classList.add('is-visible') })
      return
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          io.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' })

    nodes.forEach(function (n) { io.observe(n) })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind)
  } else {
    bind()
  }
})()
